import { WrappedCacheEntry } from '@auth0/auth0-spa-js/dist/typings/cache';
import { Cacheable, ICache, LocalStorageCache } from '@rhg/libs/auth0';

const isWrappedCacheEntry = (value: Cacheable): value is WrappedCacheEntry => {
    return (value as WrappedCacheEntry).expiresAt !== undefined;
};

const piiProperties = [
    'email',
    'family_name',
    'given_name',
    'name',
    'nickname',
    'picture',
];

export class Auth0Cache implements ICache {
    private localStorageCache: LocalStorageCache;

    constructor() {
        this.localStorageCache = new LocalStorageCache();
    }

    async set<T = Cacheable>(key: string, value: T) {
        // Remove PII from the cache
        if (isWrappedCacheEntry(value as Cacheable)) {
            if ((value as WrappedCacheEntry).body.decodedToken?.claims) {
                piiProperties.forEach((prop) => {
                    delete (value as WrappedCacheEntry).body.decodedToken
                        ?.claims[prop];
                });
            }
            if ((value as WrappedCacheEntry).body.decodedToken?.user) {
                piiProperties.forEach((prop) => {
                    delete (value as WrappedCacheEntry).body.decodedToken?.user[
                        prop
                    ];
                });
            }
        }

        this.localStorageCache.set(key, value);
    }

    async get<T = Cacheable>(key: string) {
        return this.localStorageCache.get<T>(key) as T;
    }

    remove(key: string) {
        this.localStorageCache.remove(key);
    }

    allKeys() {
        return this.localStorageCache.allKeys();
    }
}
